import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Layout } from "../components/Layout";
import Seo from "../components/Seo";
import { useContent } from "../context/ContentContext";

export default function RedirectOrNotFound() {
  const navigate = useNavigate();
  const { p } = useContent();
  const c = p("not_found").main;
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const path = window.location.pathname;
    api.get("/redirects").then((r) => {
      const exact = r.data.find((x) => x.old_path === path);
      const prefix = r.data
        .filter((x) => x.old_path !== "/" && (path === x.old_path || path.startsWith(x.old_path + "/")))
        .sort((a, b) => b.old_path.length - a.old_path.length)[0];
      const match = exact || prefix;
      if (match) {
        navigate(match.new_path, { replace: true });
      } else {
        setChecked(true);
      }
    }).catch(() => setChecked(true));
    // eslint-disable-next-line
  }, []);

  if (!checked) return <div className="min-h-screen" />;

  return (
    <Layout>
      <div className="max-w-2xl mx-auto px-5 py-32 text-center min-h-[60vh]" data-testid="not-found">
        <Seo title="Page Not Found — CaminoSapiens" description="This path leads nowhere." noindex />
        <p className="overline mb-4">{c.eyebrow}</p>
        <h1 className="font-display text-5xl">{c.heading}</h1>
        <p className="text-[#4A4947] mt-6">{c.body}</p>
        <a href="/" className="inline-block link-underline text-sm mt-8">{c.link_label}</a>
      </div>
    </Layout>
  );
}
